import { Alert, styled } from '@mui/material';

export const AlertStyled = styled(Alert)(() => ({
  color: '#EC4A67',
  background: '#FAD2D9',
  minHeight: '48px',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  position: 'fixed',
  bottom: '0',
  width: 'calc(100% - 80px - 48px)',
  zIndex: 1200,
  '.MuiAlert-message': {
    display: 'flex',
    alignItems: 'center',
  },
  '.MuiAlert-action': {
    color: '#EC4A67',
    paddingTop: '0',
    alignItems: 'center',
  },
}));
